import { IconProps } from '../../types/components';

export const PrimaryMarketIcon = ({
  fillColor = 'currentColor',
  cy,
}: IconProps) => {
  return (
    <svg
      width="26"
      height="19"
      viewBox="0 0 28 19"
      xmlns="http://www.w3.org/2000/svg"
      cy={cy}
    >
      <path
        d="M13.17 2.70001L6 7.48001V18H11V10H15V18H20V7.25001L13.17 2.70001Z"
        fill={fillColor}
      />
      <path
        d="M25.3701 18H23.4087V12.6299C23.4087 12.4818 23.4108 12.2998 23.415 12.084C23.4193 11.8639 23.4256 11.6396 23.4341 11.4111C23.4425 11.1784 23.451 10.9689 23.4595 10.7827C23.4129 10.8377 23.3177 10.9329 23.1738 11.0684C23.0342 11.1995 22.903 11.318 22.7803 11.4238L21.7139 12.2808L20.7681 11.1001L23.7578 8.71973H25.3701V18Z"
        fill={fillColor}
      />
      <path
        d="M13.5 0V1.51L11.0385 2.84L8.90923 4H7.34615V4.85L4.88461 6.19V8H2.42308V10H4.88461V12H2.42308V14H4.88461V18H0V9V0H13.5ZM2.42308 6H4.88461V4H2.42308V6Z"
        fill={fillColor}
      />
    </svg>
  );
};
